import { render, staticRenderFns } from "./ExtraDatas.vue?vue&type=template&id=3aaa1121&"
import script from "./ExtraDatas.vue?vue&type=script&lang=js&"
export * from "./ExtraDatas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports